import styled from 'styled-components'

const FooterWrapper = styled.div`
    padding: 24px;
    background: #FFFFFF;
    margin-top: 30px;

    .inner-container {
        padding: 16px 32px 0 32px;
    }

    .inner-container h1 {
        margin: 0;
        padding: 0;
    }

    .footer-top {
        display: grid;
        grid-template-columns: 3fr 1fr 1fr;
        padding: 16px;
    }

    .footer-top div:nth-child(1) p {
        font-size: 12px;
        line-height: 24px;
        margin-top: 12px;
        text-align: left;
    }

    .footer-top-items {
        border-bottom: 2px solid #FAF000;
        padding: 16px;
    }

    .footer-top-items h2 {
        color: #333;
        font-weight: 800;
        margin: 0;
        padding: 0;
        font-size: 14px;
        text-align: left;
        word-wrap: break-word;

    }

    .footer-top-items:nth-child(1) {
        padding-right: 16px;
        display: flex;
        flex-direction: column;
    }

    .footer-top-items:not(:nth-child(1)) {
        border-left: 2px solid #FAF000;
        padding-left: 16px;
    }

    .footer-top img {
        width: 156px;
    }

    .aus-mariberasuransi {
        display: flex;
        align-items: center;

        img {
            max-width: 100px;
            height: 40px;
        }
    }

    .socmed {
        display: flex;
        gap: 16px;
        margin-top: 32px;
        margin-bottom: 32px;
        cursor: pointer;
    }

    .socmed img {
        width: 32px;
    }

    .footer-top-items ul {
        margin: 0;
        padding-left: 0;
        padding-top: 24px;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .footer-top-items ul li {
        list-style: none;
        text-align: left;
    }

    .footer-top-items ul li a {
        text-decoration: none;
        color: #000;
        font-size: 14px;
    }

    .footer-with-logo {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        line-height: 18px;
        cursor: normal;
    }

    .footer-with-logo img {
        width: 24px;
    }

    .footer-bottom {
        margin-bottom: 0;
        padding-bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 32px;
        font-size: 14px;
        font-weight: 500;
        color: #333;

        a {
            text-decoration: underline;
            color: #000;
        }
        p {
            margin: 0;
        }
    }

     .clickable {
        cursor: pointer;
        transition: font-weight 0.5s ease;

        &:hover {
            font-weight: 700;
        }
    }


    .privacy-policy {
        display: flex;
        gap: 24px;
    }

    .arrow {
        display: none;
    }

    /* Responsive styling */
    @media (max-width: 1024px) {
        .footer-top {
            grid-template-columns: 1fr 1fr;
            gap: 16px;
        }

        .footer-top-items {
            padding: 16px 8px;
            border: none;
        }
        .footer-top-items:not(:nth-child(1)) {
            border-left: none;
        }
    }

    @media (max-width: 768px) {
        .footer-top {
            grid-template-columns: 1fr;
        }

        .footer-top-items {
            padding: 0 0 16px 0;
            border-left: none;
            border-bottom: 2px solid #FAF000;
        }

        .footer-top-items:not(:nth-child(1)) {
            border-left: none;
        }

        .footer-bottom {
            flex-direction: column;
            padding: 16px;
            gap: 8px;
            font-size: 12px;
        }

        .footer-bottom p{
            margin: 0;
            padding: 0;
        }

        .footer-top-items {
            font-size: 12px;
        }

        .footer-top-items ul {
            margin: 0;
            padding-left: 0;
            padding-top: 0;
            display: flex;
            flex-direction: column;
            gap: 24px;
            overflow: hidden;
            max-height: 0;
            transition: max-height 0.5s ease-in-out, padding 0.5s ease-in-out;
        }

        .footer-top-items.open ul {
            padding-top: 24px;
            max-height: 500px;
            transition: max-height 0.5s ease-in-out, padding 0.5s ease-in-out;
        }

        .arrow {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            padding: 8px;
        }

        .arrow img {
            width: 15px;
            transition: transform 0.5s ease;
        }

        .footer-top-items.open .arrow img {
            transform: rotate(180deg);
        }

        .footer-top-items h2 {
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: center;
        }
    }

    @media (max-width: 480px) {
        .inner-container {
            padding: 0;
        }
        .socmed {
            gap: 12px;
            margin-top: 32px;
            margin-bottom: 32px;
        }

        .footer-top-items {
            .tap-insure-logo {
                position: relative;
                left: 10%;
            }
        }

        .footer-top-items:nth-child(1) {
            align-items: center;

            p {
                text-align: center !important;
            }
        }
    }
`

export default FooterWrapper
